import React from 'react';
import PropTypes from 'prop-types';
import { Route, useLocation } from 'react-router-dom';
import { Button } from 'semantic-ui-react';
import { authAPI, useCustomer, useCurrentUser } from '../../_services';
import { isAON, isAONorConvertingtoAON } from '../../utils';
import { Container, Image, Menu, Dropdown, Grid } from 'semantic-ui-react';
import { Breadcrumbs } from './Breadcrumbs';

import './TopMenu.css';

const AccountMenu = ({
  mobile,
  onClickLogin,
  onClickSignUp,
  profile,
  customer
}) => {
  const {
    currentUser,
    currentUserCan,
    currentUserIsCustomer,
    currentUserIsMonitor,
    customerId
  } = useCurrentUser();

  if (!currentUser) return <></>;

  if (currentUserIsCustomer) {
    const onboarded =
      localStorage.getItem('customerOnboarded') === 'true' &&
      localStorage.getItem('accountOnboarded') === 'true';
    const aonHostData = localStorage.getItem('currentUserAonHost');
    return (
      <Menu.Item>
        <Route
          render={({ history }) => (
            <Dropdown icon="bars large">
              <Dropdown.Menu>
                {isAONorConvertingtoAON(customer) && !onboarded ? (
                  <Dropdown.Item
                    icon="home"
                    text="Dashboard"
                    onClick={() => {
                      // Force page reload for dashboard
                      document.location.href = '/customer/dashboard';
                    }}
                  />
                ) : (
                  <Dropdown.Item
                    icon="id card outline"
                    text="Profile"
                    onClick={() => {
                      history.push(`/account/${customerId}`);
                    }}
                  />
                )}
                {/* {aonHostData ? (
                    <Dropdown.Item
                      icon="file alternate outline"
                      text="HOME Statement"
                      onClick={() => {
                        history.push(`/customer/aon/statement`);
                      }}
                  />
                ) : (
                  ''
                )} */}
                {onboarded ? (
                  <>
                    <Dropdown.Item
                      icon="checkmark box"
                      text="Preferences"
                      onClick={() => {
                        history.push(`/customer/preferences`);
                      }}
                    />
                    <Dropdown.Item
                      icon="lightning"
                      text="Charging Session"
                      onClick={() => {
                        history.push(`/customer/charging`);
                      }}
                    />
                  </>
                ) : (
                  ''
                )}
                {onboarded && !isAON(customer) ? (
                  <>
                    <Dropdown.Item
                      icon="magnify"
                      text="DEICER"
                      onClick={() => {
                        history.push(`/customer/deicer`);
                      }}
                    />
                    <Dropdown.Item
                      icon="file alternate outline"
                      text="Statement"
                      onClick={() => {
                        history.push(`/customer/statement`);
                      }}
                    />
                  </>
                ) : (
                  ''
                )}
                {/* {aonHostData && onboarded && isAON(customer) ? ( - disabled for now.
                  <Dropdown.Item
                    icon="file alternate outline"
                    text="HOME Statement"
                    onClick={() => {
                      history.push(`/customer/aon/statement`);
                    }}
                  />
                ) : (
                  ''
                )} */}
                {onboarded ? (
                  <>
                    <Dropdown.Item
                      icon="user md"
                      text="Support"
                      onClick={() => {
                        history.push(`/customer/support`);
                      }}
                    />
                  </>
                ) : (
                  ''
                )}
                {onboarded && !isAON(customer) ? (
                  <>
                    <Dropdown.Item
                      icon="user md"
                      text="Charging Rates"
                      onClick={() => {
                        history.push(`/customer/charging_rates`);
                      }}
                    />
                  </>
                ) : (
                  ''
                )}
                <Dropdown.Item
                  icon="file alternate outline"
                  text="Terms and Conditions"
                  onClick={() => {
                    if (isAON(customer))
                      window.open(
                        'https://trojan.energy/consumerterms',
                        '_blank'
                      );
                    else history.push('/customer/terms');
                  }}
                />
                <Dropdown.Divider />
                <Dropdown.Item
                  text="Logout"
                  onClick={() => {
                    authAPI.logout();
                  }}
                />
              </Dropdown.Menu>
            </Dropdown>
          )}
        />
      </Menu.Item>
    );
  }

  if (currentUserIsMonitor) {
    return (
      <Menu.Item>
        <Route
          render={({ history }) => (
            <Dropdown icon="bars large">
              <Dropdown.Menu>
                <Dropdown.Item
                  icon="home"
                  text="Dashboard"
                  onClick={() => {
                    history.push(`/admin`);
                  }}
                />
              </Dropdown.Menu>
            </Dropdown>
          )}
        />
      </Menu.Item>
    );
  }

  return (
    <Menu.Item>
      <Route
        render={({ history }) => (
          <Dropdown icon="bars large">
            <Dropdown.Menu>
              <Dropdown.Item
                icon="home"
                text="Dashboard"
                onClick={() => {
                  history.push(`/admin`);
                }}
              />
              <Dropdown.Item
                icon="bell"
                text="Alerts"
                onClick={() => {
                  history.push(`/admin/alerts`);
                }}
              />
              {currentUserCan('DoAllTheThings') && (
                <>
                  <Dropdown.Item
                    icon="history"
                    text="Audit"
                    onClick={() => {
                      history.push(`/admin/audit`);
                    }}
                  />
                  <Dropdown.Item
                    icon="users"
                    text="Users"
                    onClick={() => {
                      history.push(`/admin/users`);
                    }}
                  />
                </>
              )}
              {currentUserCan('ViewCustomer') && (
                <Dropdown.Item
                  icon="users"
                  text="Customers"
                  onClick={() => {
                    history.push(`/admin/customers`);
                  }}
                />
              )}
              {currentUserCan('ViewLance') && (
                <Dropdown.Item
                  icon="filter"
                  text="Lances"
                  onClick={() => {
                    history.push(`/admin/lances`);
                  }}
                />
              )}
              <Dropdown.Item
                icon="sitemap"
                text="HUBs"
                onClick={() => {
                  history.push(`/admin/hubs`);
                }}
              />
              {currentUserCan('DoAllTheThings') && (
                <>
                  <Dropdown.Item
                    icon="pound sign"
                    text="Billing"
                    onClick={() => {
                      history.push(`/admin/billing`);
                    }}
                  />
                </>
              )}
              {currentUserCan('ViewPendingBills') && (
                <>
                  <Dropdown.Item
                    icon="pound sign"
                    text="Pending Bills (Old)"
                    onClick={() => {
                      history.push(`/admin/pending-bills`);
                    }}
                  />
                  <Dropdown.Item
                    icon="pound sign"
                    text="Pending Bills (New)"
                    onClick={() => {
                      window.location.href = `/admin-portal?category=money_movements&transaction_types=CUSTOMER_PAYMENT&transaction_statuses=PENDING%2CFAILED&is_aon_host=false`;
                    }}
                  />
                  <Dropdown.Item
                    icon="pound sign"
                    text="All Transactions (New)"
                    onClick={() => {
                      window.location.href = `/admin-portal?transaction_statuses=PENDING`;
                    }}
                  />
                  <Dropdown.Item
                    icon="id card outline"
                    text="HOME Account Management (New)"
                    onClick={() => {
                      window.location.href = `/admin-portal/accounts`;
                    }}
                  />
                </>
              )}
              {currentUserCan('ViewAON') && (
                <>
                  <Dropdown.Item
                    icon="id card outline"
                    text="Trojan Home Postcode Approval"
                    onClick={() => {
                      history.push(`/admin/aon/postcodes`);
                    }}
                  />
                  <Dropdown.Item
                    icon="id card outline"
                    text="Trojan Home Surveys"
                    onClick={() => {
                      history.push(`/admin/aon/surveys`);
                    }}
                  />
                </>
              )}
              <Dropdown item text="Documentation">
                <Dropdown.Menu>
                  <Dropdown.Item
                    icon="file"
                    text="Technical Documentation"
                    onClick={() => history.push(`/doc_controller`)}
                  />
                  <Dropdown.Item
                    icon="file"
                    text="Support - HUB"
                    onClick={() => {
                      const url = '/doc_support_hub';
                      window.open(url, '_blank').focus();
                    }}
                  />
                  <Dropdown.Item
                    icon="file"
                    text="Support - HOME"
                    onClick={() => {
                      const url = '/doc_support_aon';
                      window.open(url, '_blank').focus();
                    }}
                  />
                </Dropdown.Menu>
              </Dropdown>
              <Dropdown.Item
                icon="map"
                text="Map"
                onClick={() => history.push(`/admin/map`)}
              />
              {currentUserCan('DoAllTheThings') && (
                <Dropdown.Item
                  icon="file"
                  text="BETA"
                  onClick={() => history.push(`/admin/beta`)}
                />
              )}
              <Dropdown.Item
                icon="id card outline"
                text="Profile"
                onClick={() => {
                  history.push('/account');
                }}
              />
              <Dropdown.Divider />
              <Dropdown.Item
                text="Logout"
                onClick={() => {
                  authAPI.logout();
                }}
              />
            </Dropdown.Menu>
          </Dropdown>
        )}
      />
    </Menu.Item>
  );
};

const DesktopContainer = ({
  profile,
  customer,
  customerId,
  breadcrumbs,
  children
}) => (
  <Container>
    <Grid centered padded>
      <Grid.Column style={{ maxWidth: 500 }}>
        <br />
        <br />
        <br />
        <Image
          src="/images/TEL_logo_land_neg_outline_teal.png"
          style={{ marginLeft: '1em', marginRight: '1.5em' }}
          className="tel-logo"
          onClick={() => {
            document.location.href = '/';
          }}
        />
        <Menu
          inverted
          secondary
          borderless
          size="large"
          className="top-menu bg-black tel-top-menu"
        >
          <Menu.Menu position="right" style={{ marginRight: '1em' }}>
            <AccountMenu
              profile={profile}
              customer={customer}
              customerId={customerId}
              breadcrumbs={breadcrumbs}
              children={children}
            />
          </Menu.Menu>
        </Menu>
        {children}
      </Grid.Column>
    </Grid>
  </Container>
);

const MobileAndDesktopContainer = ({
  profile,
  customer,
  customerId,
  breadcrumbs,
  children
}) => (
  <div>
    <Button
      className="home-screen"
      color="olive"
      style={{ display: 'none', width: '100%' }}
    >
      Install app to home screen
    </Button>
    {breadcrumbs ? <Breadcrumbs /> : ''}
    <DesktopContainer
      profile={profile}
      customer={customer}
      customerId={customerId}
      breadcrumbs={breadcrumbs}
      children={children}
    />
  </div>
);

const TopMenu = ({ children }) => {
  const location = useLocation();
  const { customerId } = useCurrentUser();
  const { customer } = useCustomer(customerId);
  const profile = (!!customerId && customer) || {};

  const publicRoutes = [
    '/health',
    '/activate',
    '/login/activate',
    '/login',
    '/login_tfa',
    '/resetPassword',
    '/forgotPassword',
    '/customer/aon_survey'
  ].includes(location.pathname);
  const breadcrumbs = customerId ? false : !publicRoutes;

  return (
    <div>
      <MobileAndDesktopContainer
        profile={profile}
        customer={customer}
        customerId={customer?.id}
        breadcrumbs={breadcrumbs}
        children={children}
      />
    </div>
  );
};

TopMenu.propTypes = {
  children: PropTypes.node
};

export { TopMenu };
